var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { FormFieldContext } from '@atomic/obj.form';
import { SelectIconStyled, SelectStyled, SelectWrapperStyled } from './select.component.style';
export class SelectField extends React.Component {
    constructor(props) {
        var _a;
        super(props);
        this.handleSelectChange = (event) => {
            var _a, _b;
            const value = event.currentTarget.value;
            (_b = (_a = this.props).onValueChange) === null || _b === void 0 ? void 0 : _b.call(_a, value);
            if (this.isControlled()) {
                return;
            }
            if (this.formFieldConsumer) {
                this.formFieldConsumer.onValueChange(value, { touched: true });
            }
            else {
                this.setState({ value });
            }
        };
        this.isControlled = () => {
            return this.props.value !== undefined;
        };
        this.state = { value: (_a = this.props.initialValue) !== null && _a !== void 0 ? _a : this.props.value };
    }
    componentDidMount() {
        if (this.isControlled() && this.props.initialValue !== undefined) {
            throw new Error('Use either the initialValue prop, or the value prop, but not both');
        }
        if (this.formFieldConsumer) {
            if (this.isControlled() || this.props.initialValue !== undefined) {
                if (this.formFieldConsumer.value) {
                    throw new Error('Please, use either value props in <Select> or <Form.Field> component.');
                }
                this.formFieldConsumer.onValueChange(this.state.value, null);
            }
        }
    }
    componentDidUpdate(prevProps) {
        var _a, _b, _c;
        if (prevProps.value !== this.props.value && this.props.value !== this.state.value) {
            this.setState({ value: this.props.value });
            (_b = (_a = this.props).onValueChange) === null || _b === void 0 ? void 0 : _b.call(_a, this.props.value);
            (_c = this.formFieldConsumer) === null || _c === void 0 ? void 0 : _c.onValueChange(this.props.value, null);
        }
    }
    render() {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const _a = this.props, { type, onChange, invalid, onValueChange, value } = _a, other = __rest(_a, ["type", "onChange", "invalid", "onValueChange", "value"]);
        return (React.createElement(FormFieldContext.Consumer, null, (formFieldConsumer) => {
            var _a;
            this.formFieldConsumer = formFieldConsumer;
            const val = (_a = formFieldConsumer === null || formFieldConsumer === void 0 ? void 0 : formFieldConsumer.value) !== null && _a !== void 0 ? _a : this.state.value;
            return (React.createElement(SelectWrapperStyled, { disabled: this.props.disabled, invalid: this.props.invalid },
                React.createElement(SelectStyled, Object.assign({ onChange: this.handleSelectChange, value: val }, other), this.props.children),
                React.createElement(SelectIconStyled, null)));
        }));
    }
}
